import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import { useTranslation } from '../hooks/useTranslation';

const COOKIE_CONSENT_KEY = 'supervisor_cookie_consent';

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!consent) {
      // Small delay before showing for better UX
      const timer = setTimeout(() => setIsVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'accepted');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:max-w-sm z-50 animate-fade-in">
      <div className="bg-white/95 backdrop-blur-sm rounded-xl shadow-lg border border-gray-200 p-4">
        <div className="flex items-start gap-3">
          <div className="flex-1">
            <p className="text-sm text-gray-600 leading-relaxed">
              {t('cookie.message')}
            </p>
          </div>
          <button
            onClick={handleAccept}
            className="text-gray-400 hover:text-gray-600 transition-colors p-1"
            aria-label="Close"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
        <div className="mt-3 flex items-center gap-3">
          <button
            onClick={handleAccept}
            className="text-xs font-medium text-[#7876bb] hover:text-[#6665a8] transition-colors"
          >
            {t('cookie.accept')}
          </button>
          <span className="text-gray-300">|</span>
          <a
            href="/privacy"
            className="text-xs text-gray-500 hover:text-gray-700 transition-colors"
          >
            {t('cookie.learnMore')}
          </a>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
